import PropTypes from 'prop-types';
import { IconEye } from '../General/IconEye';
import { toast } from '../../utilities/appToast';
import { useState } from 'react';

export const InputPassword = ({ inputId, value, onChange, label, autoComplete, styles, name = null, inputStyles = "" }) => {
    const [show, setShow] = useState(false);

    const toggleVisibility = () => {
        if (value.length === 0) {
            toast.warn("Ingrese contraseña");
            return;
        }
        setShow(!show);
    };

    return (
        <div className={styles}>
            <div className="form-group">
                <label htmlFor={inputId} className="label-oscura">
                    {label}
                </label>
                <div className="input-group">
                    <input
                        id={inputId}
                        type={show ? "text" : "password"}
                        className={`form-control ${inputStyles}`}
                        value={value || ""}
                        onChange={onChange}
                        autoComplete={autoComplete}
                        name={name}
                    />
                    <button
                        type="button"
                        className="btn btn-link"
                        onClick={toggleVisibility}
                    >
                        <IconEye isHidden={show} />
                    </button>
                </div>
            </div>
        </div>
    );
}
InputPassword.propTypes = {
    inputId: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    label: PropTypes.string,
    autoComplete: PropTypes.string,
    styles: PropTypes.string,
    name: PropTypes.string,
    inputStyles: PropTypes.string,
}